
<section class="container">
  <div class="title mb-3 mb-md-4">
    <h2>Начислим кэшбэк до 10% при&nbsp;покупке ОСАГО от&nbsp;«АльфаСтрахования»</h2>
  </div>

  <app-alfa-id [isLoadApp]="isLoading" [forProlongation]="false" [forRefusalTraffic]="true"></app-alfa-id>
</section>


@if (isLoading) {
  <div class="m-5 d-flex justify-content-center">
    <div class="spinner-border" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
}

